@if (!partner?.prospect) {
  <div class="row mb-3 g-3">
    <div class="col-4">
      <div class="card shadow border-0 fade-in-zoom">
        <div class="card-body d-flex justify-content-between">
          <div>
            @if (loaded) {
              <h2 class="fs-2 fw-bold mb-0 text-primary">{{ partnerStat.currentYearToDate.revenue | money }}</h2>
            } @else {
              <h2 class="fs-2 fw-bold mb-0 text-primary"><span class="spinner-border spinner-border-sm opacity-50" role="status"><span class="visually-hidden">Loading...</span></span></h2>
            }
            <p class="mb-0 text-primary">INCOMES {{ currentYear }}</p>
            @if (loaded) {
              <small class="text-muted">Incomes {{ lastYear }}: {{ partnerStat.lastYearToDate.revenue | money }}
                @if (!isInfinite(getRevenue())) {
                  @if (hasIncreased(getRevenue())) {
                    <span class="text-success ms-2">
                      <i class="bi bi-graph-up-arrow mx-2"></i>+{{ getChange(getRevenue()) }}
                    </span>
                  }
                  @if (!hasIncreased(getRevenue())) {
                    <span class="text-danger ms-2">
                      <i class="bi bi-graph-down-arrow mx-2"></i>-{{ getChange(getRevenue()) }}
                    </span>
                  }
                }
              </small>
            } @else {
              <small>&nbsp;</small>
            }
          </div>
          <div><i class="bi bi-currency-exchange fs-1 text-muted opacity-25"></i></div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card shadow border-0 fade-in-zoom">
        <div class="card-body d-flex justify-content-between">
          <div>
            @if (loaded) {
              <h2 class="fs-2 fw-bold mb-0 text-primary">{{ partnerStat.currentYearToDate.cost | money }}</h2>
            } @else {
              <h2 class="fs-2 fw-bold mb-0 text-primary"><span class="spinner-border spinner-border-sm opacity-50" role="status"><span class="visually-hidden">Loading...</span></span></h2>
            }
            <p class="mb-0 text-primary">COST {{ currentYear }}</p>
            @if (loaded) {
              <small class="text-muted">Cost {{ lastYear }}: {{ partnerStat.lastYearToDate.cost | money }}
                @if (!isInfinite(getCost())) {
                  @if (hasIncreased(getCost())) {
                    <span class="text-success ms-2">
                      <i class="bi bi-graph-up-arrow mx-2"></i>+{{ getChange(getCost()) }}
                    </span>
                  }
                  @if (!hasIncreased(getCost())) {
                    <span class="text-danger ms-2">
                      <i class="bi bi-graph-down-arrow mx-2"></i>-{{ getChange(getCost()) }}
                    </span>
                  }
                }
              </small>
            } @else {
              <small>&nbsp;</small>
            }
          </div>
          <div><i class="bi bi-calculator fs-1 text-muted opacity-25"></i></div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card shadow border-0 fade-in-zoom">
        <div class="card-body d-flex justify-content-between">
          <div>
            @if (loaded) {
              <h2 class="fs-2 fw-bold mb-0 text-primary">{{ (partnerStat.currentYearToDate.revenue - partnerStat.currentYearToDate.cost) | money }}</h2>
            } @else {
              <h2 class="fs-2 fw-bold mb-0 text-primary"><span class="spinner-border spinner-border-sm opacity-50" role="status"><span class="visually-hidden">Loading...</span></span></h2>
            }
            <p class="mb-0 text-primary">MARGIN {{ currentYear }}</p>
            @if (loaded) {
              <small class="text-muted">Margin {{ lastYear }}: {{ (partnerStat.lastYearToDate.revenue - partnerStat.lastYearToDate.cost) | money }}
                @if (!isInfinite(getMargin())) {
                  @if (hasIncreased(getMargin())) {
                    <span class="text-success ms-2">
                      <i class="bi bi-graph-up-arrow mx-2"></i>+{{ getChange(getMargin()) }}
                    </span>
                  }
                  @if (!hasIncreased(getMargin())) {
                    <span class="text-danger ms-2">
                      <i class="bi bi-graph-down-arrow mx-2"></i>-{{ getChange(getMargin()) }}
                    </span>
                  }
                }
              </small>
            } @else {
              <small>&nbsp;</small>
            }
          </div>
          <div><i class="bi bi-pie-chart fs-1 text-muted opacity-25"></i></div>
        </div>
      </div>
    </div>
  </div>
}
